import cn from "classnames";
import Loader from "components/shared/loader";
import { bidTypesEnum, featureModuleTypesEnum } from "helpers/enums";
import policy from "policies";
import React from "react";
import BidsSortableList from "./bidsSortableList";
import Bid from "./item";
import MultipleActions from "./multipleActions";

export default class BidList extends BidsSortableList {
    state = {
        openedDropd: [],
        selectedItems: [],
    };

    constructor(props) {
        super(props);
        const { availableFeatureModules } = this.props.profile;
        this.factoringEnabled =
            availableFeatureModules.includes(featureModuleTypesEnum.Factoring) &&
            !policy("user", { user: { roles: this.props.roles } }).isOnlyExtendedViewer();
    }

    get RowComponent() {
        return Bid;
    }

    renderRow = (item, index) => {
        const Row = this.RowComponent;
        const checked = !!this.props.checkedItems?.find((id) => id === item.id);
        const {
            roles,
            enums,
            history,
            showFullAddress,
            showFactDates,
            params,
            organization,
            profile,
            modal,
            showAllPointAddresses,
            showLogistColumn,
            showOrganizationColumn,
            showCostAwareValues,
            organizationTimezone,
            getList,
        } = this.props;
        const {
            isTruckingOrganizationAdmin,
            isTruckingOrganizationManager,
            isTruckingOrganizationOperator,
            isTruckingOrganizationViewer,
            isTruckingOrganizationDispatcher,
            isTruckingOrganizationExtendedViewer,
        } = roles;
        const { selectedItems } = this.state;

        const isTruckingOrg =
            isTruckingOrganizationAdmin ||
            isTruckingOrganizationManager ||
            isTruckingOrganizationOperator ||
            isTruckingOrganizationViewer ||
            isTruckingOrganizationDispatcher ||
            isTruckingOrganizationExtendedViewer;

        if (item.isAccepted || (isTruckingOrg && item.type === bidTypesEnum.Private)) {
            return (
                <Row
                    key={item.id}
                    className={this.context.prevItemId === item.id ? "book-tr__prev-row" : ""}
                    selected={selectedItems.find((el) => el.id === item.id)}
                    factoringEnabled={this.factoringEnabled}
                    toggleItem={this.toggleItem}
                    {...{
                        item,
                        roles,
                        enums,
                        checked,
                        history,
                        showFullAddress,
                        showFactDates,
                        index,
                        params,
                        organization,
                        profile,
                        modal,
                        showAllPointAddresses,
                        showLogistColumn,
                        showOrganizationColumn,
                        showCostAwareValues,
                        organizationTimezone,
                        getList,
                    }}
                />
            );
        } else {
            return null;
        }
    };

    toggleAll = (e) => {
        e.stopPropagation();
        if (Object.keys(this.state.selectedItems).length === this.props.items.length) {
            this.setState({ selectedItems: [] });
        } else {
            const selectedItems = this.props.items.reduce((acc, item) => {
                acc.push({ id: item.id, status: item.status, lastBidPoint: item.lastBidPoint });
                return acc;
            }, []);
            this.setState({ selectedItems });
        }
    };

    toggleItem = ({ id, status, lastBidPoint }) => {
        const { selectedItems } = this.state;
        const index = selectedItems.findIndex((item) => item.id === id);
        index >= 0 ? delete selectedItems[index] : selectedItems.push({ id, status, lastBidPoint });
        this.setState({ selectedItems: selectedItems.filter((item) => item) });
    };

    resetItems = () => this.setState({ selectedItems: [] });

    thead = () => {
        return (
            <thead className="thead-light sticky-header">
                <tr className="b-table__header">
                    {this.factoringEnabled && (
                        <th>
                            <div className="px-2" onClick={this.toggleAll}>
                                <span
                                    className={cn("checkbox", {
                                        "checkbox--checked":
                                            Object.keys(this.state.selectedItems).length === this.props.items.length,
                                    })}
                                />
                            </div>
                        </th>
                    )}
                    <th>#</th>
                    <th className={this.headerClass("id")}>{this.sortableDropdHeader("id", "ID")}</th>
                    <th className={this.headerClass("from")}>{this.sortableDropdHeader("from", "Откуда")}</th>
                    {this.props.showAllPointAddresses && <th>Транзит</th>}
                    <th className={this.headerClass("to")}>{this.sortableDropdHeader("to", "Куда")}</th>
                    <th className={this.headerClass("car")}>
                        {this.sortableDropdHeader("car", "Груз, машина, водитель")}
                    </th>
                    {this.props.showLogistColumn && <th>Логист, колонна</th>}
                    <th>{this.props.showCostAwareValues ? "Стоимость с учётом затрат, контрагент" : "Стоимость, контрагент"}</th>
                    {this.props.showOrganizationColumn && <th>Организация</th>}
                    <th className={this.headerClass("status")}>{this.sortableDropdHeader("status", "Статус")}</th>
                </tr>
            </thead>
        );
    };

    tbody = () => {
        const { items } = this.props;
        return items && items.length ? (
            items.map(this.renderRow)
        ) : (
            <tr>
                <td colSpan={7} className="text-center">
                    Не найдено
                </td>
            </tr>
        );
    };

    table = () => {
        const { isLoadingList } = this.props;
        if (isLoadingList) {
            return <Loader prefix="absolute-center" />;
        }
        return (
            <table className="table table-hover table-clickable table-sm">
                {this.thead()}
                <tbody>{this.tbody()}</tbody>
            </table>
        );
    };

    render() {
        const { items, modal, getList, params, isLoadingList } = this.props;
        const { selectedItems } = this.state;
        const props = { selectedItems, items, modal, getList, params, resetItems: this.resetItems, isLoadingList };
        return (
            <>
                {this.factoringEnabled && <MultipleActions {...props} />}
                <div className="list__body-wrap">
                    <div className="list__body">
                        <div className="container-fluid h-100">
                            <div
                                className="table-responsive content-wrapper h-100"
                                onScroll={this.scrollHandler}
                                ref={(el) => (this.scrollContainer = el)}
                            >
                                {this.table()}
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderPagination()}
            </>
        );
    }
}
